// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"f53115e9","316":"b9a690b3","416":"8f896d3f","990":"d728e61a"}[chunkId] + ".chunk.js";
};